import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { getRespuestasIndividuales } from '../../api/formularios';

interface Props {
  open: boolean;
  formularioId?: number | null;
  usuarioId?: number | null;
  onClose: () => void;
}

export default function VerRespuestasDialog({ open, formularioId, usuarioId, onClose }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [respuestas, setRespuestas] = useState<any[]>([]);

  useEffect(() => {
    if (!open || !formularioId) return;
    const load = async () => {
      setLoading(true);
      try {
        const data = await getRespuestasIndividuales(formularioId, {
          usuarioId: usuarioId || undefined,
          page: 1,
          limit: 100,
        });
        setRespuestas(data.data || []);
      } catch (error: any) {
        enqueueSnackbar(error?.response?.data?.message || 'Error al cargar respuestas', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [open, formularioId, usuarioId, enqueueSnackbar]);

  return (
    <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
      <DialogTitle>Respuestas</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Stack alignItems="center" py={4}>
            <CircularProgress />
          </Stack>
        ) : (
          <Paper elevation={0} sx={{ p: 1 }}>
            {respuestas.length === 0 ? (
              <Typography align="center" sx={{ py: 3 }}>- No hay respuestas -</Typography>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Pregunta</TableCell>
                    <TableCell>Respuesta</TableCell>
                    <TableCell>Fecha</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {respuestas.map((r: any, idx: number) => (
                    <TableRow key={idx}>
                      <TableCell>{r.preguntaTexto || '-'}</TableCell>
                      <TableCell>{r.valorDisplay || r.respuestaTexto || r.valor || '-'}</TableCell>
                      <TableCell>
                        {r.createdAt ? new Date(r.createdAt).toLocaleString('es-ES') : '-'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
